import React, { useEffect } from 'react';
import { getPolicyOptions } from '../services/apiService';

const ParameterSelection = ({
  selectedAge,
  selectedSA,
  onAgeSelect,
  onSASelect,
  policyData,
  onRunComparison
}) => {

  const [policyOptions, setPolicyOptions] = React.useState(null);
  const [loadingOptions, setLoadingOptions] = React.useState(true);

  useEffect(() => {
    loadPolicyOptions();
  }, []);
useEffect(() => {
  if (selectedAge && selectedSA) {
    onRunComparison("table");  
  }
}, [selectedAge, selectedSA]);
  const loadPolicyOptions = async () => {
    try {
      const options = await getPolicyOptions();
    
      setPolicyOptions(options);
    } catch (err) {

      setPolicyOptions({});
    } finally {
      setLoadingOptions(false);
    }
  };

  const dataToRender =
    Array.isArray(policyData) && policyData.length > 0
      ? policyData
      : [];

 

  useEffect(() => {
   
  }, [policyData]);
  const ages = policyOptions?.ages || [];
  const sumAssuredOptions = policyOptions?.sumAssured || [];

  const ageValues = ages.map(age =>
    typeof age === "object" ? age.value || age.id || age.label : age
  );

  const sumAssuredValues = sumAssuredOptions.map(sa =>
    typeof sa === "object" ? sa.value || sa.id || sa.label : sa
  );

  const formatCurrency = (value) => {
    if (!value) return "-";
    return "₹" + Number(value).toLocaleString("en-IN");
  };

  const formatSA = (value) => {
    const num = Number(value);
    if (isNaN(num)) return "-";
    if (num >= 10000000) return "₹ " + (num / 10000000).toFixed(0) + " Cr";
    if (num >= 100000) return "₹ " + (num / 100000).toFixed(0) + " L";
    return "₹ " + num.toLocaleString("en-IN");
  };

  if (loadingOptions) return <p>Loading options...</p>;

  return (
    <>
      <div style={{ marginBottom: '18px' }}>
        <div className="label-sm">👤 Customer Age</div>
        <div className="btn-group">
          {ageValues.map((age, index) => (
            <button
              key={`${age}-${index}`}
              className={`btn-age ${selectedAge === age ? 'active' : ''}`}
              onClick={() => onAgeSelect(age)}
            >
              {age} Yrs
            </button>
          ))}
        </div>
      </div>
      <div style={{ marginBottom: '18px' }}>
        <div className="label-sm">💰 Sum Assured</div>
        <div className="btn-group">
          {sumAssuredValues.map((sa, index) => {
            if (typeof sa !== "number") return null;
            return (
              <button
                key={`${sa}-${index}`}
                className={`btn-sa ${selectedSA === sa ? 'active' : ''}`}
                onClick={() => onSASelect(sa)}
              >
                {formatSA(sa)}
              </button>
            );
          })}
        </div>
      </div>
{selectedAge && selectedSA && (
  <div>
    <hr className="section-divider" />

    <div className="label-sm">
      📄 Policy Details Comparison
    </div>
    <div className="policy-table-wrapper">

      <table className="policy-table">
        <thead>
          <tr>
            <th>Parameter</th>

            {dataToRender.map((comp) => (
              <th key={comp._id || comp.name}>
                {comp.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>PPT</td>

            {dataToRender.map((comp) => (
              <td
                key={comp._id || comp.name}
                className="td-green"
              >
                {comp?.ppt
                  ? `${comp.ppt} Years`
                  : "-"}
              </td>
            ))}
          </tr>
          <tr>
            <td>Policy Term</td>

            {dataToRender.map((comp) => (
              <td
                key={comp._id || comp.name}
                className="td-green"
              >
                {comp?.pt
                  ? `${comp.pt} Years`
                  : "-"}
              </td>
            ))}
          </tr>
          <tr>
            <td>Annual Premium</td>

            {dataToRender.map((comp) => (
              <td
                key={comp._id || comp.name}
                className="td-green"
              >
                {comp?.annualPremium
                  ? formatCurrency(comp.annualPremium)
                  : "-"}
              </td>
            ))}
          </tr>
          <tr>
            <td>Total Premium Paid</td>

            {dataToRender.map((comp) => (
              <td
                key={comp._id || comp.name}
                className="td-green"
              >
                {comp?.totalPremiumPaidLabel || "-"}
              </td>
            ))}
          </tr>

        </tbody>

      </table>

    </div>

    <button
      className="btn-compare"
      onClick={() => onRunComparison("full")}
    >
      📊 Compare Now — View Full Fund Value Chart →
    </button>

  </div>
)}
    </>
  );
};

export default ParameterSelection;